import { Row, Col } from "../../App.styles";
import { Switch } from "../../common/Switch";

const LocksSection = ({ useQuery }) => {
  const {
    hide_locked,
    unlock_by_task_id,
    unlock_by_task_txt,
    unlock_by_location_radius,
  } = useQuery();

  return (
    <>
      <Row>
        <Col>
          <p>
            Lock by: {!!unlock_by_task_id && "Challenge"}
            {!!unlock_by_location_radius && "Location"}
            {!unlock_by_task_id && !unlock_by_location_radius && "Unlocked"}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>If locked, show in challenges list:</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Switch
            labels={{ on: "Show", off: "Hide" }}
            name="hide_locked"
            on={0}
            off={1}
            value={hide_locked}
            useQuery={() => [{ hide_locked }, () => null]}
          />
        </Col>
      </Row>
      {!!unlock_by_task_id && (
        <Row>
          <Col>
            <p>Unlock by Completing: {unlock_by_task_txt}</p>
          </Col>
        </Row>
      )}
    </>
  );
};

export default LocksSection;
